/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty */

import React, { useEffect, useState } from "react";
import GlobalTable from "../../../components/global-table";
import useAPIHandler from "../../../hook/use-api-handler";
import {
  Box,
  Button,
  Col,
  Dialog,
  Divider,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import { extractOnlyNumbers, getDateProperFormatForInput, parseOnlyNumericValue, removeAllSpaces, removeExtraSpace, safeToString, sliceText } from "../../../utils/common";

import useSnackbar from "../../../hook/use-snakbar";
import { Snackbar } from "../../../ppui/snackbar";
import {  removeMultipleSpace, safeString } from "../../../utils/logger";
import { ContentBody, ContentHeading, ContentLayout, ContentTable } from "../../style";

import { BRANCH_INITIAL_STATE } from "./branch-constant";
import { branchSchema } from "./branch-validation";
import { headers } from "../../organization/organization.data";


function OrganizationBranch() {
  const {
    snackbarVisible,
    snackbarMessage,
    // snackbarDuration,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();
  const { fetchData } = useAPIHandler()
  const [branchData, setBranchData] = useState([]);
  const [allState, setAllState] = useState([]);
  const [errors, setErrors] = useState({});
  const [open, setOpen] = React.useState(false);
  // const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const handleClickOpen = () => {
    setErrors({})
    setBranchInfo(structuredClone(BRANCH_INITIAL_STATE))
    setOpen(true)

  };
  const handleClickOpenEditModal = (data) => {
    setErrors({})
    setOpen(true);
    setBranchInfo({
      ...data, date_of_est: getDateProperFormatForInput(data?.date_of_est)
    });
    // setOpen(false)
  }

  const [branchInfo, setBranchInfo] = useState(BRANCH_INITIAL_STATE)
  const fetchBranchData = async () => {
    try {
      const result = await fetchData({
        url: 'organization/org-branch',
        method: 'GET',
      });
      // const mappedData = result?.data?.map(({ org_branches: item }, index) => ({
      const mappedData = result?.data?.map((item, index) => ({
        ...item,
        slNo: index + 1,
        status: item?.status,
        name: item?.branch_name,
        mobileNo: item?.contact_number,
        emailId: item?.email,
        address: item?.address,
        contactPerson: item?.contact_person,
        dateOfEstablished: getDateProperFormatForInput(item?.date_of_est)
      }));
      setBranchData(mappedData);

    } catch {
    }
  }

  const fetchAllState = async () => {

    try {
      const response = await fetchData({
        url: '/common/state',
        method: "GET",
      })
      if (response?.status === 'success' && Array.isArray(response?.data)) {
        const mappedData = response?.data?.map((item) => ({
          id: item?.state_id,
          name: item?.state_name
        }))
        setAllState(mappedData)

      }
    } catch (error) {

    }

  }
  const handleChange = (e, name) => {
    // const { name, value } = e.target;
    let value = e;
    if (e && e.target) {
      value = e.target.value;
      name = e.target.name
    }
    if (name === "pincode") {
      value = sliceText(parseOnlyNumericValue(removeAllSpaces(value)), 6);
    }
    if (name === "email") {
      value = removeExtraSpace(value);
    }
    if (name === "branch_name") {
      value = sliceText(removeMultipleSpace(safeToString(value)), 150);
    }
    if (name === "address") {
      value = sliceText(removeMultipleSpace(safeToString(value)), 150);
    }
    if (name === "contact_person") {
      value = sliceText(removeMultipleSpace(safeToString(value)), 150);
    }
    if (name === "city") {
      value = sliceText(removeMultipleSpace(safeToString(value)), 150);
    }
    if (name === "landmark") {
      value = sliceText(removeMultipleSpace(safeToString(value)), 150);
    }
    if (name === "locality") {
      value = sliceText(removeMultipleSpace(safeToString(value)), 150);
    }
    if(name ==="contact_number"){
      value=sliceText(removeAllSpaces(extractOnlyNumbers(value)),11);
    }
    setBranchInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value
    }));

    const fieldSchema = branchSchema.extract(name);
    const { error } = fieldSchema.validate(value);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));

  }
  const handleSubmit = async () => {
    const {
      branch_name,
      contact_number,
      contact_person,
      email,
      date_of_est,
      address,
      locality,
      city,
      state,
      country,
      pincode,
      landmark,
    } = branchInfo || {};
    const { error } = branchSchema.validate({
      branch_name,
      contact_number,
      contact_person,
      email,
      date_of_est,
      address,
      locality,
      city,
      state,
      country,
      pincode,
      landmark,
    }, {
      abortEarly: false,
    });

    if (error && error?.details?.length > 0) {
      const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);
      // setCreateUpdateLoading(false);

    } else {
      setErrors({});
      try {
        const url = branchInfo?.branch_id ?
          `organization/modify-org-branch/${branchInfo?.branch_id}` :
          `organization/create-org-branch`;
        const payload = {
          url: url,
          method: 'POST',
          data: {
            branch_name,
            contact_number,
            contact_person,
            email,
            date_of_est: date_of_est ?? null,
            address,
            locality,
            city,
            state,
            country: safeString(country),
            pincode: safeString(pincode),
            // pincode,
            landmark,
          }
        }

        if (branchInfo?.branch_id) {
          payload.data.status = true
        }
        const response = await fetchData(payload);

        if (response.status === 'success') {
          // await fetchOrgBranchData();
          setBranchInfo(BRANCH_INITIAL_STATE)
          fetchBranchData()
          openSnackbar({ message: "Branch updated successfully!" });
        }
        handleClose()
      } catch (error) {
        handleClose()

        if (error?.type === "JoiValidationError") {
          const errorsAll = {};
          error?.errors?.reduce((acc, curr) => {
            const { field, message } = curr;

            errorsAll[field] = message;

            return acc;
          });

          openSnackbar({
            message:
              Object.keys(errorsAll).length > 0
                ? "Validation Error!"
                : "Something went wrong!",
            color: "danger",
          });

          setErrors(errorsAll);
        }
      }
    }
  }

 
  useEffect(() => {
    fetchBranchData();
    fetchAllState();

     fetchData({
      url: 'organization/org-branch',
      method: 'GET',
    }).then(res=>{
    
      if(!res?.data?.length){
        // navigate("/branch")
      }
    })
  }, [])

  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };


  return (
    <>
      <ContentLayout>
        {branchData.length <= 0 &&
          <ContentBody Padding>
            <Row rowGap>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Branch Name"
                  name="branch_name"
                  placeholder="Type Here"
                  type="text"
                  value={branchInfo.branch_name}
                  valueSinc={!!branchInfo.branch_name}
                  onChange={(e) => handleChange(e.target.value, "branch_name")}
                  error={errors.branch_name}
                  helperText={errors.branch_name}
                  required={true}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Branch Contact"
                  name="contact_number"
                  placeholder="Type Here"
                  type="tel"
                  value={branchInfo.contact_number}
                  valueSinc={!!branchInfo.contact_number}
                  onChange={(e) => handleChange(e.target.value, "contact_number")}
                  error={errors.contact_number}
                  helperText={errors.contact_number}
                  required={true}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Branch Email"
                  name="email"
                  placeholder="Type Here"
                  type="tel"
                  value={branchInfo.email}
                  valueSinc={!!branchInfo.email}
                  onChange={(e) => handleChange(e.target.value, "email")}
                  error={errors.email}
                  helperText={errors.email}
                  required={true}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Contact Person"
                  name="contact_person"
                  placeholder="Type Here"
                  type="tel"
                  value={branchInfo.contact_person}
                  valueSinc={!!branchInfo.contact_person}
                  onChange={(e) => handleChange(e.target.value, "contact_person")}
                  error={errors.contact_person}
                  helperText={errors.contact_person}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Date Of Established"
                  name="date_of_est"
                  placeholder="Type Here"
                  type="date"
                  value={branchInfo.date_of_est}
                  // defaultValue={branchInfo.date_of_est}
                  valueSinc
                  onChange={(e) => handleChange(e.target.value, "date_of_est")}
                  error={errors.date_of_est}
                  helperText={errors.date_of_est}
                  max={getTodayDate()}
                  onKeyDown={e => e.preventDefault()}
                />
              </Col>
            </Row>

            <Divider gap={20} />
            <Typography variant="h5">Branch Address</Typography>
            <Row rowGap>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Address"
                  name="address"
                  placeholder="Type Here"
                  type="text"
                  value={branchInfo.address}
                  valueSinc={!!branchInfo.address}
                  onChange={(e) => handleChange(e.target.value, "address")}
                  error={errors.address}
                  helperText={errors.address}
                />
              </Col>

              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Locality"
                  name="locality"
                  placeholder="Type Here"
                  type="text"
                  value={branchInfo.locality}
                  valueSinc={!!branchInfo.locality}
                  onChange={(e) => handleChange(e.target.value, "locality")}
                  error={errors.locality}
                  helperText={errors.locality}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="City/District"
                  name="city"
                  placeholder="Type Here"
                  type="text"
                  value={branchInfo.city}
                  valueSinc={!!branchInfo.city}
                  onChange={(e) => handleChange(e.target.value, "city")}
                  error={errors.city}
                  helperText={errors.city}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <SelectField
                  fullWidth
                  label="State"
                  name="state"
                  options={allState}
                  placeholder="Type here..."
                  defaultValue={branchInfo.state}
                  valueSinc={!!branchInfo.state}
                  onChange={(val) => handleChange(val, 'state')}
                  error={errors.state}
                  helperText={errors.state}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <SelectField
                  fullWidth
                  label="Country"
                  name="country"
                  options={[
                    { id: 'india', name: "India" },
                  ]}
                  valueSinc
                  defaultValue={branchInfo?.country}
                  disabled
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Pincode"
                  name="pincode"
                  type="text"
                  placeholder="Type Here"
                  // value={sliceText(parseOnlyNumericValue(removeAllSpaces(branchInfo.pincode)), 6)}
                  value={branchInfo.pincode}
                  valueSinc={!!branchInfo.pincode}
                  onChange={(e) => handleChange(e.target.value, "pincode")}
                  error={errors.pincode}
                  helperText={errors.pincode}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Landmark"
                  name="landmark"
                  placeholder="Type Here"
                  type="text"
                  value={branchInfo.landmark}
                  valueSinc={!!branchInfo.landmark}
                  onChange={(e) => handleChange(e.target.value, "landmark")}
                  error={errors.landmark}
                  helperText={errors.landmark}
                />
              </Col>
            </Row>

            <Gap height={20} />
            <Flex justifyContent="flex-end" gap={"10"}>
              <Button variant="outlined">
                Cancel
              </Button>

              <Button onClick={() => handleSubmit()} color="primary" variant="contained">
                Save
              </Button>
              <Snackbar
                message={snackbarMessage}
                color={snackColor}
                variant="contained"
                size="medium"
                position="top-right"
                onClose={
                  closeSnackbar}
                onOpen={snackbarVisible}
                loading={false}
                duration={3000}
              />
            </Flex>
          </ContentBody>
        }
        {branchData.length > 0 &&
          <>
            <ContentHeading>
              <Typography variant="h5" mb="0">
                Branch List
              </Typography>
              <Button color="primary" variant="contained" onClick={handleClickOpen}>
                Add Branch
              </Button>
            </ContentHeading>
            <ContentTable >
              <GlobalTable
                headers={headers}
                rows={branchData || []}
                // TableActionShow={false}
                avatar={false}
                stickyHeader="true"
                setData={(value) => {
                  // setBranchInfo({
                  //   ...value, date_of_est: getDateProperFormatForInput(value?.date_of_est)
                  // })
                  handleClickOpenEditModal(value)
                }}
              />
            </ContentTable>
          </>
        }
      </ContentLayout>
      {/* Modal */}
      <Dialog
        title="Create New Branch"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={() => handleSubmit()}
        separator
        setData={(value) => {
          setBranchInfo({
            ...value, date_of_est: getDateProperFormatForInput(value?.date_of_est)
          })
        }}
      >
        <Row rowGap>
          <Col sm={6}>
            <Box>
              <InputField
                fullWidth
                label="Branch Name"
                name="branch_name"
                placeholder="Type Here"
                type="text"
                value={branchInfo.branch_name}
                valueSinc={!!branchInfo.branch_name}
                onChange={(e) => handleChange(e.target.value, "branch_name")}
                error={errors.branch_name}
                helperText={errors.branch_name}
                required={true}
              />
            </Box>
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Branch Contact"
              name="contact_number"
              placeholder="Type Here"
              type="tel"
              value={branchInfo.contact_number}
              valueSinc={!!branchInfo.contact_number}
              onChange={(e) => handleChange(e.target.value, "contact_number")}
              error={errors.contact_number}
              helperText={errors.contact_number}
              required={true}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Branch Email"
              name="email"
              placeholder="Type Here"
              type="tel"
              value={branchInfo.email}
              valueSinc={!!branchInfo.email}
              onChange={(e) => handleChange(e.target.value, "email")}
              error={errors.email}
              helperText={errors.email}
              required={true}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Contact Person"
              name="contact_person"
              placeholder="Type Here"
              type="tel"
              value={branchInfo.contact_person}
              valueSinc={!!branchInfo.contact_person}
              onChange={(e) => handleChange(e.target.value, "contact_person")}
              error={errors.contact_person}
              helperText={errors.contact_person}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Date Of Established"
              name="date_of_est"
              placeholder="Type Here"
              type="date"
              value={branchInfo.date_of_est}
              defaultValue={branchInfo.date_of_est}
              valueSinc
              onChange={(e) => handleChange(e.target.value, "date_of_est")}
              error={errors.date_of_est}
              helperText={errors.date_of_est}
              max={getTodayDate()}
              onKeyDown={e => e.preventDefault()}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Address"
              name="address"
              placeholder="Type Here"
              type="text"
              value={branchInfo.address}
              valueSinc={!!branchInfo.address}
              onChange={(e) => handleChange(e.target.value, "address")}
              error={errors.address}
              helperText={errors.address}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Locality"
              name="locality"
              placeholder="Type Here"
              type="text"
              value={branchInfo.locality}
              valueSinc={!!branchInfo.locality}
              onChange={(e) => handleChange(e.target.value, "locality")}
              error={errors.locality}
              helperText={errors.locality}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="City/District"
              name="city"
              placeholder="Type Here"
              type="text"
              value={branchInfo.city}
              valueSinc={!!branchInfo.city}
              onChange={(e) => handleChange(e.target.value, "city")}
              error={errors.city}
              helperText={errors.city}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              fullWidth
              label="State"
              name="state"
              options={allState}
              placeholder="Type here..."
              defaultValue={branchInfo.state}
              valueSinc={!!branchInfo.state}
              onChange={(val) => handleChange(val, 'state')}
              error={errors.state}
              helperText={errors.state}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              fullWidth
              label="Country"
              name="country"
              options={[
                { id: 'india', name: "India" },
              ]}
              valueSinc
              defaultValue={branchInfo?.country}
              disabled
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Pincode"
              name="pincode"
              type="text"
              placeholder="Type Here"
              value={branchInfo.pincode}
              valueSinc={!!branchInfo.pincode}
              onChange={(e) => handleChange(e.target.value, "pincode")}
              error={errors.pincode}
              helperText={errors.pincode}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Landmark"
              name="landmark"
              placeholder="Type Here"
              type="text"
              value={branchInfo.landmark}
              valueSinc={!!branchInfo.landmark}
              onChange={(e) => handleChange(e.target.value, "landmark")}
              error={errors.landmark}
              helperText={errors.landmark}
            />
          </Col>
        </Row>
      </Dialog>
      {/* Modal */}
    </>
  );
}

export default OrganizationBranch;
